import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Hook to automatically update user activity on route changes
 * This resets the 8-hour inactivity timer when user navigates
 */
export const useActivityTracker = () => {
  const { isAuthenticated, updateActivity } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated) {
      updateActivity();
    }
  }, [location.pathname, isAuthenticated, updateActivity]);
};

export default useActivityTracker;
